import _ from 'lodash';
import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

const getters = {
  [getterTypes.GET_EVENT_REGISTRATION_FIELDS]: state => state.fields,
  [getterTypes.GET_EVENT_REGISTRATION_PARTICIPANTS]: state => state.participants,
};

const actions = {
  async [actionTypes.DO_CREATE_EVENT_REGISTRATION]({ commit }, payload) {
    const { id, ...params } = payload;
    const { data } = await HTTP.post(`/events/${id}/registrations`, params);
    commit(mutationTypes.SET_EVENT_REGISTRATION, data.data.registrations[0]);
    return data;
  },
};

const mutations = {
  [mutationTypes.ADD_EVENT_REGISTRATION_PARTICIPANT](state, participant) {
    state.participants.push(participant);
  },
  [mutationTypes.SET_EVENT_REGISTRATION](state, registration) {
    state.registration = registration;
  },
  [mutationTypes.SET_EVENT_REGISTRATION_FIELD](state, payload) {
    const index = _.findIndex(state.fields, { form_field_id: payload.form_field_id });
    if (index >= 0) {
      Vue.set(state.fields, index, payload);
    } else {
      state.fields.push(payload);
    }
  },
  [mutationTypes.SET_EVENT_REGISTRATION_FIELDS](state, payload) {
    state.fields = payload;
  },
  [mutationTypes.SET_EVENT_REGISTRATION_PARTICIPANTS](state, payload) {
    state.participants = payload;
  },
  [mutationTypes.SET_EVENT_REGISTRATION_PARTICIPANT_FIELD](state, payload) {
    const participant = state.participants[payload.index];
    delete payload.index;
    const index = _.findIndex(participant, { form_field_id: payload.form_field_id });
    if (index >= 0) {
      Vue.set(participant, index, payload);
    } else {
      participant.push(payload);
    }
  },
  [mutationTypes.REMOVE_EVENT_REGISTRATION_PARTICIPANT](state, index) {
    state.participants.splice(index, 1);
  },
};

export default {
  state: {
    fields: [],
    participants: [[]],
    registration: {},
  },
  getters,
  actions,
  mutations,
};
